// extracted by mini-css-extract-plugin
export var checkboxList = "index-module--checkbox-list--PXTWf";
export var featuresWrapper = "index-module--features-wrapper--CMH8i";
export var featuresWrapperDesc = "index-module--features-wrapper-desc--tIcQ2";
export var right = "index-module--right--7EVHH";
export var screenImage = "index-module--screen-image--wazhZ";